import type { SectionProps } from "../types";
import { values } from "../data";

export default function ValuesSection({ isVisible, sectionRef }: SectionProps) {
  return (
    <section
      ref={sectionRef}
      data-section="values"
      className="py-16 sm:py-20 md:py-24 bg-gray-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div
          className={`text-center mb-10 sm:mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
          }`}
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-[#2a4b7c] mb-3 sm:mb-4 px-4">
            Giá Trị Học Viên Nhận Được
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            Không chỉ là kiến thức, mà là sự thay đổi toàn diện
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className={`group text-center transition-all duration-700 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-[#2a4b7c] rounded-xl sm:rounded-2xl mb-3 sm:mb-4 md:mb-6 mx-auto group-hover:bg-cyan-500 transition-all duration-300 group-hover:scale-110 group-hover:rotate-6 shadow-lg">
                <i className={`${value.icon} text-2xl sm:text-3xl md:text-4xl text-white`}></i>
              </div>
              <h3 className="text-sm sm:text-base md:text-lg lg:text-xl font-bold text-[#2a4b7c] mb-2 sm:mb-3 px-2">
                {value.title}
              </h3>
              <p className="text-xs sm:text-sm md:text-base text-gray-600 leading-relaxed px-2">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

